<template>
  <div class="box">
    <div class="aboutTitle">宣传栏目</div>
    <video type="video/mp4" loop='true' autoplay="true" controls class="videoMain"  :src="video.mediaUrl"></video><!-- -->
  </div>
</template>

<script>
  import {getLibraryVideo} from "@/api/study"
  export default{
    props:{
      play:{
        type:Boolean,
        default:false
      }
    },
    data(){
      return{
        libraryId: null,
        filter: {
          currentPage: 1,
          pageSize: 10,
          libraryId: null,
        },
        videoList: [],
        video:{},
      }
    },
    created() {
      if (this.$route.query.libraryId) {
        this.libraryId = this.$route.query.libraryId;
        this.filter.libraryId = this.libraryId;
      }
      this.getVideo();


    },
    mounted() {
      console.log('play=======',this.play)
    },
    methods:{
      openVoice() {
          var videoPlayer = document.getElementById("homeVideo")
          videoPlayer.muted = false
          videoPlayer.play()
      },
      getVideo(){
        getLibraryVideo(this.filter).then(response=>{
          this.videoList = response.data;
          if (this.videoList.length>0) {
            this.video = this.videoList[0];
            console.log(this.videoList[0])
            //console.log("视频链接：" + this.video.mediaUrl);
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  .box{
    background: url(../../static/minBg.png) no-repeat;
    background-size: 100% 100%;
    width: 48.75%;
    height: 558px;
    overflow: hidden;
  }
  .aboutTitle{
    margin-top: 12px;
    margin-left: 20px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    text-align: left;
  }
  .videoMain{
    width: 100%;
    height: 480px;
    margin: 10px auto 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/video.vue